<lyceo-ui-modal-header
  class="mb-2"
  [text]="modalTitle()"
  (closeModal)="close()"
/>
<p class="mb-2">
  {{ modalBodyText() }}
</p>
<a
  lyceoButton
  [block]="true"
  target="_blank"
  class="button"
  href="mailto:{{ email }}?{{ mailToQueryParams() }}"
  (click)="close()"
>
  {{ modalButtonText() }}
</a>
